import { Link } from 'react-router-dom';
import type { SessionWorkItem, SessionWorkItemKind } from '@localagent/sdk';

const KIND_LABELS: Record<SessionWorkItemKind, string> = {
  goal: 'Goal',
  project: 'Project',
  task: 'Task',
};

interface SessionWorkItemBadgeProps {
  item: SessionWorkItem;
}

function workItemHref(item: SessionWorkItem): string {
  if (item.work_item_kind === 'goal') {
    return `/work/teams/${item.team_id}/goals/${item.work_item_id}/projects`;
  }
  if (item.work_item_kind === 'project' && item.goal_id) {
    return `/work/teams/${item.team_id}/goals/${item.goal_id}/projects/${item.work_item_id}`;
  }
  if (item.work_item_kind === 'task' && item.goal_id && item.project_id) {
    return `/work/teams/${item.team_id}/goals/${item.goal_id}/projects/${item.project_id}/tickets/${item.work_item_id}`;
  }
  if (item.work_item_kind === 'task') {
    return `/work/teams/${item.team_id}/tickets/${item.work_item_id}`;
  }
  return `/work/teams/${item.team_id}`;
}

function summary(item: SessionWorkItem): string {
  if (item.work_item_kind === 'task' && item.ticket_title) {
    return item.ticket_title;
  }
  if (item.work_item_kind === 'project' && item.project_name) {
    return item.project_name;
  }
  if (item.work_item_kind === 'goal' && item.goal_objective) {
    return item.goal_objective;
  }
  return item.identifier;
}

export function SessionWorkItemBadge({ item }: SessionWorkItemBadgeProps) {
  const kindLabel = KIND_LABELS[item.work_item_kind];
  const title = summary(item);

  return (
    <Link
      to={workItemHref(item)}
      onClick={(e) => e.stopPropagation()}
      title={`Open ${kindLabel.toLowerCase()} on its team board`}
      data-testid={`session-work-item-${item.session_id}`}
      data-work-item-kind={item.work_item_kind}
      data-work-item-id={item.work_item_id}
      className="mt-0.5 block truncate text-micro text-muted-foreground hover:text-foreground"
    >
      {kindLabel}: {title}
    </Link>
  );
}
